interface ErrorCode {
  code: string;
  http_status_code: number;
  category: string;
  message: string;
}

export const errorCodes: ErrorCode[] = [
  {
    code: '0000',
    http_status_code: 200,
    category: '성공',
    message: '성공',
  },
  {
    code: '1000',
    http_status_code: 400,
    category: '입력 데이터 오류',
    message: '필수 입력 값이 누락되었습니다.',
  },
  {
    code: '1001',
    http_status_code: 400,
    category: '입력 데이터 오류',
    message: '입력 형식이 잘못되었습니다.',
  },
  {
    code: '1002',
    http_status_code: 401,
    category: '인증 오류',
    message: '유효하지 않은 API 키입니다.',
  },
  {
    code: '1003',
    http_status_code: 401,
    category: '인증 오류',
    message: '액세스 토큰이 만료되었습니다.',
  },
  {
    code: '1004',
    http_status_code: 403,
    category: '권한 오류',
    message: '해당 리소스에 대한 권한이 없습니다.',
  },
  {
    code: '1005',
    http_status_code: 400,
    category: '리소스 오류',
    message: '요청한 데이터를 찾을 수 없습니다.',
  },
  {
    code: '1006',
    http_status_code: 0,
    category: '인증 오류',
    message: '재발송은 하루 5회만 가능합니다.',
  },
  {
    code: '1007',
    http_status_code: 400,
    category: '로그인 오류',
    message: '지갑주소가 생성되지 않았습니다.',
  },
  {
    code: '1100',
    http_status_code: 400,
    category: '회원가입 오류',
    message: '입력된 이메일 주소가 유효하지 않습니다.',
  },
  {
    code: '1101',
    http_status_code: 400,
    category: '회원가입 오류',
    message: '비밀번호는 최소 8자 이상이어야 합니다.',
  },
  {
    code: '1102',
    http_status_code: 409,
    category: '회원가입 오류',
    message: '이미 등록된 이메일 주소입니다.',
  },
  {
    code: '1103',
    http_status_code: 409,
    category: '회원가입 오류',
    message: '이미 사용중인 닉네임입니다.',
  },
  {
    code: '1105',
    http_status_code: 400,
    category: '회원가입 오류',
    message: '필수 입력값이 누락되었습니다.',
  },
  {
    code: '1106',
    http_status_code: 409,
    category: '회원가입 오류',
    message: '이미 사용중인 휴대폰번호입니다.',
  },
  {
    code: '1107',
    http_status_code: 0,
    category: '회원가입 오류',
    message: '핀 번호가 형식에 맞지 않습니다.',
  },
  {
    code: '1114',
    http_status_code: 0,
    category: '회원가입 오류',
    message: '이미 등록된 휴대폰 번호입니다.',
  },
  {
    code: '1200',
    http_status_code: 401,
    category: '로그인 오류',
    message: '로그인 정보가 올바르지 않습니다.\n다시 시도해주세요',
  },
  {
    code: '1202',
    http_status_code: 423,
    category: '로그인 오류',
    message: '아이디가 일치하지 않습니다.',
  },
  {
    code: '1201',
    http_status_code: 423,
    category: '로그인 오류',
    message: '계정이 잠겼습니다. 관리자에게 문의하세요.',
  },
  {
    code: '1203',
    http_status_code: 423,
    category: '로그인 오류',
    message: '비밀번호가 여러 번 잘못 입력되어 계정이 잠겼습니다.',
  },
  {
    code: '1205',
    http_status_code: 423,
    category: '계정 오류',
    message: '핀번호를 여러 번 잘못 입력되어 계정이 잠겼습니다.',
  },
  {
    code: '1208',
    http_status_code: 423,
    category: '계정 오류',
    message: '탈퇴한 회원 정보입니다.\n 관리자에게 문의하세요.',
  },
  {
    code: '1300',
    http_status_code: 404,
    category: '계정 오류',
    message: '요청한 계정을 찾을 수 없습니다.',
  },
  {
    code: '2000',
    http_status_code: 204,
    category: '데이터베이스 오류',
    message: '인증번호가 유효하지 않습니다.',
  },
  {
    code: '2001',
    http_status_code: 500,
    category: '데이터베이스 오류',
    message: 'db 저장에 실패했습니다.',
  },
  {
    code: '2002',
    http_status_code: 500,
    category: '데이터베이스 오류',
    message: 'db 조회에 실패했습니다.',
  },
  {
    code: '2003',
    http_status_code: 500,
    category: '데이터베이스 오류',
    message: '쿼리 실행 실패',
  },
  {
    code: '3000',
    http_status_code: 500,
    category: '서버 내부 오류',
    message: '서버 처리 중 오류가 발생했습니다.',
  },
  {
    code: '3001',
    http_status_code: 503,
    category: '블록체인 오류',
    message: '블록체인 네트워크 연결에 실패했습니다.',
  },
  {
    code: '3002',
    http_status_code: 400,
    category: '블록체인 오류',
    message: '트랜잭션 서명이 유효하지 않습니다.',
  },
  {
    code: '3003',
    http_status_code: 500,
    category: '블록체인 오류',
    message: '스마트 계약 실행 중 문제가 발생했습니다.',
  },
  {
    code: '3004',
    http_status_code: 409,
    category: '블록체인 오류',
    message: '이미 존재하는 데이터입니다.',
  },
  {
    code: '3005',
    http_status_code: 409,
    category: '블록체인 오류',
    message: '중복된 트랜잭션 요청입니다.',
  },
  {
    code: '4000',
    http_status_code: 502,
    category: '외부 서비스 오류',
    message: '외부 API 응답이 실패했습니다.',
  },
  {
    code: '5000',
    http_status_code: 400,
    category: '데이터 검증 오류',
    message: '입력한 금액이 잘못되었습니다.',
  },
  {
    code: '5001',
    http_status_code: 400,
    category: '데이터 검증 오류',
    message: '지원하지 않는 토큰 형식입니다.',
  },
  {
    code: '9999',
    http_status_code: 500,
    category: '알 수 없는 오류',
    message: '알 수 없는 오류가 발생했습니다.',
  },
];
